import {
  FilledInput,
  FilledInputProps,
  InputAdornment,
  InputProps,
  useTheme,
} from '@mui/material'
import { FC, useCallback, useMemo, useState } from 'react'
import { CardFormatter } from '../../helpers/formatters'
import { PaymentProvider } from '../../third-party/PaymentProvider'
import { Fa } from '../Fa'

const CardInput: FC<CardInputProps> = (props) => {
  const theme = useTheme()

  const [raw, setRaw] = useState('')

  const handleChange: Required<InputProps>['onChange'] = useCallback((e) => {
    e.target.value = CardFormatter.format(e.target.value)
    setRaw(CardFormatter.getRaw(e.target.value))
  }, [])

  const logoName = useMemo(() => {
    if (raw.length < 16) {
      return
    }

    for (const name in numberTests) {
      const regExp = numberTests[name]

      if (regExp.test(raw)) {
        return name
      }
    }
  }, [raw])

  return (
    <>
      <FilledInput
        name="card"
        onChange={handleChange}
        slotProps={{
          input: {
            pattern: CardFormatter.pattern.source,
          },
        }}
        {...(logoName && {
          endAdornment: (
            <InputAdornment position="end">
              <Fa family="brands" name={`cc-${logoName}`} size="2xl" />
            </InputAdornment>
          ),
        })}
        {...props}
      />
      <input
        type="hidden"
        value={raw}
        id={PaymentProvider.formIds.CARD_NUMBER}
      />
    </>
  )
}

const numberTests: Record<string, RegExp> = {
  mastercard: /^2|^5/,
  visa: /^4/,
  amex: /^34|^37/,
}

type CardInputProps = Pick<
  FilledInputProps,
  'name' | 'required' | 'autoFocus'
> & {}

export { CardInput }
export type { CardInputProps }
